export const CALIBRATOR_SEARCH_URL = 'https://www.narrabri.atnf.csiro.au/cgi-bin/Calibrators/new/caldb_v3.pl';
export const CALIBRATOR_URL = 'https://www.narrabri.atnf.csiro.au/calibrators/calibrator_database_viewcal.html';

// max number of targets allowed in the catalogue
export const MAX_TARGETS_COUNT = 100;

// max number of scans allowed in the scheduel file
export const MAX_SCANS_COUNT = 100;

export const DEFAULT_INTEGRATION_TIME_S = 10.24;

// max number of charaters for filename and directory name
export const MAX_NAME_LENGTH = 30;

export const MAX_RA_DEC_LENGTH = 15;

export const MAX_DESCRIPTION_LENGTH = 150;

// value hour:minute:second.xxx, max value 24:00:00
export const RA_REGEX = /^[+]?(([0-2][0-3]|[0-1]?[0-9]):[0-5]?[0-9]:[0-5]?[0-9](\.[0-9]{0,9})?)$/;
// value deg:minute:second.xxx, max value +/-90:00:00
export const DEC_REGEX = /^[+-]?(((([0-8]?[0-9]):[0-5]?[0-9]:[0-5]?[0-9](\.[0-9]{0,9})?))|90:00:00(\.0{0,9})?)$/;


export const TARGET_NAME_REGEX = "^[+a-zA-Z0-9_.-]*$";

export const GALACTIC_LONGITUTE_RANGE = [0, 360];
export const GALACTIC_LATITUTE_RANGE = [-90, 90];

export const AZ_RANGE = [-360, 360];
export const EL_RANGE = [0, 90];

// value deg:minute:second.xxx, max value +/-90:00:00
export const LATITUTE_REGEX = '^[+-]?(((([0-8]?[0-9]):[0-5]?[0-9]:[0-5]?[0-9]))|90:00:00)$'
// value deg:minute:second.xxx, max value +/-180:00:00
export const LONGITUTE_REGEX = '^[+-]?((((1[0-7]?[0-9]|[1-9]?[0-9]):[0-5][0-9]:[0-5][0-9]))|180:00:00)$'

// speed of light km/s
export const SPEED_OF_LIGHT = 299792458/1000;
export const PROJECT_FILENAME = 'project.json';

export const SUB_BANDS_PER_IF = 15;
export const NUMBER_OF_IF = 4;

// MHz
export const IF_BAND_WIDTH = 1.92 * 1000;

// Max Band separation 
export const MAX_BAND_SPARATION = 6 * 1000;

export const CABB_BAND_WIDTH = 8 * 1000;

export const COORDINATE_SYSTEMS = ['J2000', 'B1950', 'AzEl', 'Galactic'];

export const COORDINATE_SYSTEM_FIELDS: any = {
  'J2000': { ra: 'RA', ra_format: 'hh:mm:ss', dec: 'Dec', dec_format: 'dd:mm:ss'},
  'B1950': { ra: 'RA', ra_format: 'hh:mm:ss', dec: 'Dec', dec_format: 'dd:mm:ss' },
  'AzEl': { ra: 'Az', ra_format: `deg between ${AZ_RANGE[0]} and ${AZ_RANGE[1]}`, dec: 'El', dec_format: `deg between ${EL_RANGE[0]} and ${EL_RANGE[1]}` },
  'Galactic': { ra: 'Long', ra_format: `deg between ${GALACTIC_LONGITUTE_RANGE[0]} and ${GALACTIC_LONGITUTE_RANGE[1]}`, 
    dec: 'Lat', dec_format: `deg between ${GALACTIC_LATITUTE_RANGE[0]} and ${GALACTIC_LATITUTE_RANGE[1]}` },
}

// minimun width in MHz a freq line is from the edge of the band
export const MIN_ZOOM_BANDWIDTH_GAP = 5

export const ReceiverRange = [
  { 'name': '16cm', 'start': 1000, 'end': 3300, number_of_IF: 1,
      'default_center_freq': 2112, 'default_band_setting': 'high16'},
  { 'name': '4cm', 'start': 4128, 'end': 12288, number_of_IF: 4, 
      'default_center_freq': 8208, 'default_band_setting': 'midlow'},
  { 'name': '15mm', 'start': 15000, 'end': 25500, number_of_IF: 4,
      'default_center_freq': 19840, 'default_band_setting': 'midlow'},
  { 'name': '7mm', 'start': 30000, 'end': 50000, number_of_IF: 4,
      'default_center_freq': 35726, 'default_band_setting': 'midlow'},
  { 'name': '3mm', 'start': 80512, 'end': 105000, number_of_IF: 4,
      'default_center_freq': 94000, 'default_band_setting': 'midlow'}
]

// band offsets
// https://www.narrabri.atnf.csiro.au/observing/bigcat/bigcat_rf.html
export const CABB_BAND_OFFSETS: any = {
  'band_1': {'offset_0': (5088  - 8208), 'offset_160': (5248	- 8208), 'offset_320': (5408  - 8208), 'offset_480': (5568  - 8208), 'offset_640': (5728  - 8208), 'offset_800': (5888  - 8208)},
  'band_2': {'offset_0': (7008  - 8208), 'offset_160': (7168	- 8208), 'offset_320': (7328  - 8208), 'offset_480': (7488  - 8208), 'offset_640': (7648  - 8208), 'offset_800': (7808  - 8208)},
  'band_3': {'offset_0': (8608  - 8208), 'offset_160': (8768	- 8208), 'offset_320': (8928  - 8208), 'offset_480': (9088  - 8208), 'offset_640': (9248  - 8208), 'offset_800': (9408  - 8208)},
  'band_4': {'offset_0': (10528 - 8208), 'offset_160': (10688 - 8208), 'offset_320': (10848 - 8208), 'offset_480': (11008 - 8208), 'offset_640': (11168 - 8208), 'offset_800': (11328 - 8208)}
};

// for 7mm receiver, centre freq of CABB band cannot be
// bettwe 38 and 44 GHz
export const CABB_EXCLUDEZONE_MHZ_7mm = [37392, 44508];  
export const LSB_OR_USB_MHZ_7mm = 40000;

export const ReceiverDescription: any= {
  '16cm' :
    ['2,120 - 2,340 MHz for offset 0 (high16)',
     '1,960 - 2,180 MHz for offset 160 (low16)'],
  '4cm' : ['Can\'t be set by users.', ''],
  '7mm': ['Analogue IF band centre freq has to be divisble by 3',
          `and can't be between
          ${CABB_EXCLUDEZONE_MHZ_7mm[0].toLocaleString()} - ${CABB_EXCLUDEZONE_MHZ_7mm[1].toLocaleString()}
          MHz`,]
}

export const get4cmReceiver = () => {
  const receivers = ReceiverRange.filter(
    (r) => {return r['name'] === '4cm'}
  );
  return receivers[0];
}

export const get16cmReceiver = () => {
  const receivers = ReceiverRange.filter(
    (r) => {return r['name'] === '16cm'}
  );
  return receivers[0];
}

export const Receiver16cmRange: any = {
  'offset_0': {'center_freq_start': 2110,  'center_freq_end': 2340},
  'offset_160': {'center_freq_start': 1960,  'center_freq_end': 2180},
}

export const SCAN_TYPES = ['Normal', 'Dwell', 'Mosaic', 'Point',
  'Paddle', 'Closefile', 'OTFMos'];

export const DISABLE_SCAN_TYPES = ['Closefile', 'OTFMos'];

export const POINTINGS = ['Global', 'Offset', 'Offpnt', 'Update']


// google 20c colors
export const COLOR_LIST = ["#3366cc", "#dc3912", "#ff9900", "#109618",
  "#990099", "#0099c6", "#dd4477", "#66aa00",
  "#b82e2e", "#316395", "#994499", "#22aa99",
  "#aaaa11", "#6633cc", "#e67300", "#8b0707",
  "#651067", "#329262", "#5574a6", "#3b3eac"];

export const ARRAY_HELP_URL = 'https://www.narrabri.atnf.csiro.au/operations/array_configurations/configurations.html';

export const SCAN_INTENTS = {
  normal: [
    { 
      name: 'CALIBRATE_AMPLI', 
      note: 'scan to calibrate how the amplitudes have changed' 
    },
    { 
      name: 'CALIBRATE_BANDPASS', 
      note: 'scan to take data that will later be used for bandpass calibration' 
    },
    { 
      name: 'CALIBRATE_DELAY', 
      note: 'likely will always be specified along with CALIBRATE_BANDPASS' 
    },
    { 
      name: 'CALIBRATE_FLUX', 
      note: 'scan to take data that will later be used for flux density calibration' 
    },
    { 
      name: 'CALIBRATE_PHASE', 
      note: 'scan to calibrate how the phases have changed; will almost always be specified along with CALIBRATE_AMPLI' 
    },
    { 
      name: 'CALIBRATE_POINTING', 
      note: 'scan to determine local pointing offsets(the equivalent of the "Point" scan type now)',
      disabled: true
    },
    { 
      name: 'PADDLE_SCAN', 
      note: 'scan with paddle scan type',
      disabled: true
    },    
    { 
      name: 'CALIBRATE_POLARIZATION', 
      note: 'scan to take data that will later be used for polarization calibration' 
    },
    { 
      name: 'OBSERVE_TARGET', 
      note: 'take data on a scientifically- interesting source' 
    },
    { 
      name: 'CALIBRATE_POL_LEAKAGE', 
      note: 'scan to take data that will later be used for polarization leakage calibration' 
    },
    { 
      name: 'CALIBRATE_POL_ANGLE', 
      note: 'scan to take data that will later be used for polarization angle calibration' 
    },
    { 
      name: 'OBSERVE_CHECK_SOURCE', 
      note: 'take data on a source for quality assurance purposes' 
    },
  ],

  advanced: [
    { name: 'CALIBRATE_FOCUS'},
    { name: 'CALIBRATE_FOCUS_X'},
    { name: 'CALIBRATE_FOCUS_Y' },
    { name: 'CALIBRATE_WVR' },
    { name: 'DO_SKYDIP' },
    { name: 'MAP_ANTENNA_SURFACE' },
    { name: 'MAP_PRIMARY_BEAM' },
    { name: 'TEST' },
    { name: 'UNSPECIFIED' },
    { name: 'CALIBRATE_ANTENNA_POSITION' },
    { name: 'CALIBRATE_ANTENNA_PHASE' },
    { name: 'SYSTEM_CONFIGURATION' },
    { name: 'MEASURE_RFI' },
    { name: 'CALIBRATE_ANTENNA_POINTING_MODEL' }
  ],

  other: [
    { name: 'CALIBRATE_SIDEBAND_RATIO'}, 
    { name: 'CALIBRATE_APPPHASE_ACTIVE' },
    { name: 'CALIBRATE_APPPHASE_PASSIVE' },
    { name: 'CALIBRATE_DIFFGAIN ' },
  ] 
}

export const SPECTRAL_LINE_FREQUENCIES = [
  { freq: "1420.405752", name: "HI neutral hydrogen" },
  { freq: "1612.231", name: "OH hydroxyl radical" },
  { freq: "1665.402", name: "OH hydroxyl radical" },
  { freq: "1667.359", name: "OH hydroxyl radical" },
  { freq: "1720.530", name: "OH hydroxyl radical" },
  { freq: "4829.660", name: "H2CO ortho-formaldehyde" },
  { freq: "6030.747", name: "OH maser" },
  { freq: "6035.093", name: "OH maser" },
  { freq: "6668.518", name: "CH3OH methanol" },
  { freq: "9098.332", name: "HC3N cyanoacetylene" },
  { freq: "12178.593", name: "CH30H methanol" },
  { freq: "14488.490", name: "H2CO ortho-formaldehyde" },
  { freq: "18343.145", name: "C3H2 ortho-cyclopropenylidene" },
  { freq: "22235.07985", name: "H20 ortho-water" },
  { freq: "23694.506", name: "NH3 para-ammonia" },
  { freq: "23722.634", name: "NH3 para-ammonia" },
  { freq: "23870.130", name: "NH3 ortho-ammonnia" },
  { freq: "42820.570", name: "SiO silicon monoxide" },
  { freq: "43122.0900", name: "SiO silicon monoxide" },
  { freq: "43423.8530", name: "SiO silicon monoxide" },
  { freq: "48990.9640", name: "CS carbon monosulfide" },
  { freq: "72039.3310", name: "DCO+ deuterated formylium" },
  { freq: "85640.4560", name: "SiO silicon monoxide" },
  { freq: "86243.4420", name: "SiO silicon monoxide" },
  { freq: "86754.2940", name: "H13CO+ formylium" },
  { freq: "86846.9980", name: "SiO silicon monoxide" },
  { freq: "88631.8470", name: "HCN hydrogen cyanide" },
  { freq: "89188.5180", name: "HCO+ formylium" },
  { freq: "90663.5740", name: "HNC hydrogen isocyanide" },
  { freq: "93173.8090", name: "N2H+ diazenylium" },
  { freq: "97980.9680", name: "CS carbon monosulfide" },
  { freq: "109782.1820", name: "C18O carbon monoxide" },
  { freq: "110201.3700", name: "13CO carbon monoxide" },
  { freq: "115271.2030", name: "J=1-0 CO carbon monoxide" },
  { freq: "230538.0000", name: "J=2-1 CO carbon monoxide" },
  { freq: "345795.9899", name: "J=3-2 CO carbon monoxide" },
  { freq: "461040.7682", name: "J=4-3 CO carbon monoxide" },
  { freq: "576267.9305", name: "J=5-4 CO carbon monoxide" },
  { freq: "691473.0763", name: "J=6-5 CO carbon monoxide" },
  { freq: "806651.8060", name: "J=7-6 CO carbon monoxide" },
  { freq: "921799.7000", name: "J=8-7 CO carbon monoxide" }
];

export const DEFAULT_SETTING: any = {
  duration: 300,
  scanType: 'Dwell',
  pointing: 'Global',
  correlator_configuration: ''
};

export const INIT_TARGET: any = {
  name: '',
  coord_sys: 'J2000',
  ra: '',
  dec: '',
  velocity: '',
  frame: 'lsr',
  convention: 'radio',
};

export var BAND_SETTINGS: any[] = [];
export const set_band_settings = (settings: any[]) => {
  BAND_SETTINGS = settings;
}

export var SCHEDULE_SCHEMA: any  = {};
export const set_schedule_schema = (schema: any) => {
  SCHEDULE_SCHEMA = schema;
}

export var ARRAY_CONFIGURATION: any[] = [];
export const set_array_configuration = (config: any[]) => {
  ARRAY_CONFIGURATION = config;
}
